import { render, staticRenderFns } from "./detailTrainingCompleted.vue?vue&type=template&id=c03320dc&scoped=true"
import script from "./detailTrainingCompleted.vue?vue&type=script&lang=js"
export * from "./detailTrainingCompleted.vue?vue&type=script&lang=js"
import style0 from "./detailTrainingCompleted.vue?vue&type=style&index=0&id=c03320dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03320dc",
  null
  
)

export default component.exports